"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ChannelDealerCode;
(function (ChannelDealerCode) {
    /** Enrolling Application: Enrollment Portal */
    ChannelDealerCode["D2C"] = "4RUMW";
    /** Enrolling Application: Web Claim */
    ChannelDealerCode["WebMobilityClaims"] = "4RUMW";
    /** Enrolling Application: Anywhere Expert Messaging */
    ChannelDealerCode["SolutoMessagingExperts"] = "9HKJ9";
    /** Enrolling Application: Glow */
    ChannelDealerCode["SolutoProTech"] = "9HKJ9";
    /** Enrolling Application: Glow */
    ChannelDealerCode["VoiceClaims"] = "4RUMW";
    /** Enrolling Application: Field app */
    ChannelDealerCode["SameDayExperts"] = "9JATX";
    /** Enrolling Application: Field app */
    ChannelDealerCode["RemoteTech"] = "9N78P";
    /** Enrolling Application: UBIF Store Portal */
    ChannelDealerCode["RetailUBIF"] = "9N78P";
})(ChannelDealerCode = exports.ChannelDealerCode || (exports.ChannelDealerCode = {}));
